import {SimpleEventsEmailResource} from './simpleEventsEmailResource.model';

export class SimpleSavedQueryResource {
    nickname: string;
    eventsEmailResource: SimpleEventsEmailResource;

    constructor(map: SimpleSavedQueryResource = {} as SimpleSavedQueryResource) {
        this.nickname = map.nickname || null;
        this.eventsEmailResource = map.eventsEmailResource || null;
    }
}
